import { useFundFamilyEventRetrieve } from "gen/endpoints/fund-family-event/fund-family-event";
import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { FullScreenLoadingState } from "shared/components/empty/FullScreenLoadingState";
import { EqualizedViewContextProvider } from "shared/components/toggle/EqualizedViewToggleButton/EqualizedViewContext";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const PollingWrapperContext = React.createContext<{
  setShouldPoll: (shouldPoll: boolean) => Promise<void>;
}>({
  setShouldPoll: async () => {},
});

export const CapitalEventPageWrapper: React.FC = () => {
  const [shouldPoll, setShouldPoll] = React.useState(true);
  const { fundFamilyId, fundFamilyEventId } = useRequiredStringParams();

  const { data: capitalActivityData, refetch } = useFundFamilyEventRetrieve(
    fundFamilyId,
    fundFamilyEventId,
    {
      query: {
        enabled: shouldPoll,
        refetchInterval: 1000,
        throwOnError: false,
      },
    },
  );

  const contextValue = useMemo(
    () => ({
      setShouldPoll: async (flag: boolean) => {
        if (flag) {
          await refetch();
          setShouldPoll(true);
        } else {
          setShouldPoll(flag);
        }
      },
    }),
    [refetch],
  );

  return (
    <EqualizedViewContextProvider>
      <PollingWrapperContext.Provider value={contextValue}>
        {shouldPoll &&
          capitalActivityData &&
          capitalActivityData.event_workflow_status.is_running && (
            <FullScreenLoadingState
              message={capitalActivityData.event_workflow_status.message}
            />
          )}
        <Outlet />
      </PollingWrapperContext.Provider>
    </EqualizedViewContextProvider>
  );
};
